function ImageSlide({ image }) {
  console.log("Image", image);
  return (
    <div
      class="hero-image"
      style={{
        backgroundImage: `url(${image})`,
      }}
    >
      {/* <div className="main-container">
        <div className="content-container">
          <div className="hero-sub-images">
            <div className="hero-text">
              <h1>THE CHESHIRE 100 ULTRA RUN</h1>
              <h4>20th September 2025</h4>
            </div>
          </div>
        </div>
      </div> */}
    </div>
  );
}

export { ImageSlide };
